import { P2GChip, P2GIcon } from '@parcel2go/core-ui';
import { SvgDelete } from '@parcel2go/core-ui';
import { useTranslation } from 'react-i18next';
import { TranslationNamespaces } from '~/lib/constants';

interface props {
  tag: string;
  onRemove?: (tag: string) => void;
  color?: 'primary' | 'secondary' | 'default' | 'success' | 'error' | 'info' | 'danger' | 'warning';
}

export default function ItemTag(props: props) {
  const { t } = useTranslation(TranslationNamespaces.SMARTSEND);
  if (props.tag === 'ReturnCollection') {
    return (
      <P2GChip color="primary" size="small" label={t('TAG_RETURN_LABEL_TITLE', { defaultValue: 'Return Label' })} />
    );
  }

  if (!props.onRemove) {
    return <P2GChip color={props.color || 'primary'} size="small" label={props.tag} />;
  }

  return (
    <P2GChip
      color="primary"
      size="small"
      label={props.tag}
      clickable={!!props.onRemove}
      onDelete={() => props.onRemove && props.onRemove(props.tag)}
      deleteIcon={
        props.onRemove && (
          <P2GIcon>
            <SvgDelete />
          </P2GIcon>
        )
      }
    />
  );
}
